import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Patient} from '../../../../../persistence/src/models/patient.model';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'burncase-patient-dialog',
    templateUrl: './patient-dialog.component.html',
    styleUrls: ['./patient-dialog.component.css']
})
export class PatientDialogComponent implements OnInit {
    date: FormControl;

    constructor(
        public dialogRef: MatDialogRef<PatientDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Patient) {
        this.date = new FormControl(this.data.birthdate);
    }

    ngOnInit(): void {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}
